<template>
  <div
    class="table-container content_w_710"
    :class="[
      device.isMobile ? 'table-container-mobile' : '',
      content.styleType === 2 ? 'table-container-en' : '',
    ]"
    :id="content.key"
  >
    <!-- <el-tabs :id="`${content.key}-1`" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane
        v-for="item in content.content"
        :key="item.key"
        :label="item.tabText"
        :name="item.key"
      >
        <tableComponent :tableData="item.tableData" :headerData="item.tableHeader"></tableComponent>
      </el-tab-pane>
    </el-tabs> -->
    <div class="table-tabs" :id="`${content.key}-1`" v-if="content.content.length > 1">
      <div
        v-for="(item, index) in content.content"
        :key="index"
        class="tabs-item"
        :class="activeKey === item.key ? 'tabs-item-active' : ''"
        @click.stop="changeTabs($event, item.key)"
      >【{{ item.tabText }}】</div>
    </div>
    <div v-if="content.styleType === 2" class="reset" @click.stop="reset"></div>
    <template v-for="item in content.content">
      <tableComponent v-show="activeKey === item.key" :ref="item.key" :key="item.key" :tableData="item.tableData" :headerData="item.tableHeader" :styleType="content.styleType || 1"></tableComponent>
    </template>
    <p
      v-if="content.title"
      class="table-title"
      :id="`${content.key}-2`"
      :style="{
        fontFamily: content.titleStyle.fontFamily || '',
        fontSize: (content.titleStyle.fontSize + 'rem') || '',
        lineHeight: (content.titleStyle.lineHeight + 'rem') || '',
        textIndent: (typeof content.titleStyle.textIndent === 'string') ? content.titleStyle.textIndent :
          (typeof content.titleStyle.textIndent === 'number') ? (content.titleStyle.textIndent + 'rem') : '',
        fontWeight: content.titleStyle.fontWeight || '',
        textDecoration: content.titleStyle.underline === 1 ? 'underline' : '',
        fontStyle: content.titleStyle.fontItalic === 1 ? 'italic' : '',
        textAlign: content.titleStyle.textAlign || '',
        color: content.titleStyle.color || '',
        backgroundColor: content.titleStyle.backgroundColor || '',
      }"
      v-html="content.title"
    ></p>
  </div>
</template>
<script>
/*
表格组件
*/
import tableComponent from "./table.vue";
export default {
  name: "tableIndex",
  inject: {
    findChapterFrom: {
      default: () => {},
    },
  },
  components: {
    tableComponent
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      activeKey: '',
    }
  },
  mounted() {
    this.activeKey = this.content.content[0].key
  },
  methods: {
    changeTabs(e, key) {
      this.activeKey = key
      this.findChapterFrom(e)
    },
    reset() {
      if(Array.isArray(this.content.content)) {
        this.content.content.forEach(item => {
          const childRef = this.$refs[item.key];
          if (childRef && childRef[0]) {
            childRef[0].reset();
          }
        })
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.content_w_710 {
  width: calc(100% - 48rem);
  margin: 50rem auto;
}
.table-container{
  position: relative;
  
  .reset{
    width: 34rem;
    height: 34rem;
    background: url(~@/assets/images/books/bookExample/reset.png) center center no-repeat;
    background-size: contain;
    position: absolute;
    top: -61rem;
    right: 0;
    cursor: pointer;
    z-index: 5;
  }

  .table-tabs{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30rem;

    .tabs-item{
      font-size: 20rem;
      line-height: 42rem;
      color: #666;
      margin-right: 60rem;
      cursor: pointer;
      
      &:last-child{
        margin-right: 0;
      }
    }

    .tabs-item-active{
      color: #4B96D1;
      position: relative;

      &:after{
        content: '';
        width: 70rem;
        height: 3rem;
        position: absolute;
        bottom: -3rem;
        left: 50%;
        margin-left: -35rem;
        border-radius: 2rem;
        background: #4B96D1;
      }
    }
  }

  
  .table-title{
    display: block;
    margin-top: 15rem;
    width: 100%;
    text-align: center;
    font-size: 16rem;
    line-height: 20rem;
    color: #666;
  }
}

.table-container-en{
  width: 100%;
  margin: 0;
}

.table-container-mobile{
  
  .reset{
    width: 44rem;
    height: 44rem;
    top: -66rem;
  }

  .table-tabs{
    margin-bottom: 36rem;

    .tabs-item{
      font-size: 28rem;
      line-height: 52rem;
    }

    .tabs-item-active{
      color: #4B96D1;
      position: relative;

      &:after{
        content: '';
        width: 80rem;
        height: 6rem;
        bottom: -6rem;
        margin-left: -40rem;
        border-radius: 3rem;
      }
    }
  }

  
  .table-title{
    margin-top: 15rem;
    font-size: 20rem;
    line-height: 32rem;
    color: #666;
  }
}
</style>